(function () {
    'use strict';

    angular.module('blocks.validation', [
        'ngFluentValidation',
        'pascalprecht.translate',
        'blocks.helpers'
    ]);
})();
